export const offlineCitys = [
    {
     "OfflineCity": "Addanki"
    },
    {
     "OfflineCity": "Amalapuram"
    },
    {
     "OfflineCity": "Anantapur"
    },
    {
     "OfflineCity": "Bapatla"
    },
    {
     "OfflineCity": "Chilakaluripet"
    },
    {
     "OfflineCity": "Chittoor"
    },
    {
     "OfflineCity": "Eluru"
    },
    {
     "OfflineCity": "Gudivada"
    },
    {
     "OfflineCity": "Guntur"
    },
    {
     "OfflineCity": "Kadapa"
    },
    {
     "OfflineCity": "Kakinada"
    },
    {
     "OfflineCity": "Kurnool"
    },
    {
     "OfflineCity": "Machilipatnam"
    },
    {
     "OfflineCity": "Madanapalle"
    },
    {
     "OfflineCity": "Narasaraopet"
    },
    {
     "OfflineCity": "Nellore"
    },
    {
     "OfflineCity": "Ongole"
    },
    {
     "OfflineCity": "Palakol"
    },
    {
     "OfflineCity": "Piduguralla"
    },
    {
     "OfflineCity": "Rajahmundry"
    },
    {
     "OfflineCity": "Razole"
    },
    {
     "OfflineCity": "Repalle"
    },
    {
     "OfflineCity": "Tenali"
    },
    {
     "OfflineCity": "Tirupathi"
    },
    {
     "OfflineCity": "Tuni"
    },
    {
     "OfflineCity": "Vijayawada"
    },
    {
     "OfflineCity": "Visakhapatnam"
    },
    {
     "OfflineCity": "Hyderabad"
    },
    {
     "OfflineCity": "Kodad"
    },
    {
     "OfflineCity": "Kukatpally"
    },
    {
     "OfflineCity": "Mehdipatnam"
    },
    {
     "OfflineCity": "Mumbai"
    },
    {
     "OfflineCity": "Chandigarh"
    },
    {
     "OfflineCity": "Delhi"
    },
    {
     "OfflineCity": "Meham"
    },
    {
     "OfflineCity": "Palwal"
    },
    {
     "OfflineCity": "Rewari"
    },
    {
     "OfflineCity": "Nanded"
    },
    {
     "OfflineCity": "Belgaum"
    },
    {
     "OfflineCity": "Jalandhar"
    },
    {
     "OfflineCity": "Moga"
    }
   ]